/* 🤖 this file was generated by svg-to-ts */
export const iconSimpleMinus: {
  name: 'simple_minus';
  data: string;
} = {
  name: 'simple_minus',
  data: `<svg width="16px" height="16px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M1,9 C0.447,9 0,8.553 0,8 C0,7.447 0.447,7 1,7 L15,7 C15.553,7 16,7.447 16,8 C16,8.553 15.553,9 15,9 L1,9 Z" id="path-1"/></svg>`,
};
